<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Venta de Combustible</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <input
                  id="fechafin"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="280px">
                <Select2 v-model="cliente" :options="clientes" />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  @click="getReporteEquipos"
                >
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <DataTable
          :columns="columns"
          :data="reporte"
          :options="options"
          class="display nowrap"
          style="width: 100%"
        />
      </div>
      <div>
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr class="fila-hover">
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">
                {{ totalventas }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">TOTAL CANTIDAD</td>
              <td class="subtable b text-right">
                {{ fcantidad }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">
                {{ ftotalimpuestos }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">
                {{ ftotales }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">TOTAL DESCUENTOS</td>
              <td class="subtable b text-right">
                {{ fdescuentos }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">FECHA INICIO</td>
              <td class="subtable b text-right">
                {{ fecha_inicio_reporte }}
              </td>
            </tr>
            <tr class="fila-hover">
              <td class="subtable">FECHA FINAL</td>
              <td class="subtable b text-right">
                {{ fecha_final_reporte }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Venta # {{ venta._id }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-gray">
              <div class="bg-gray">
                <div class="bg-gray">
                  <FacturaPosView :key="facturaKey" :object="factura" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import FacturaPosView from "../../components/FacturaPosView.vue";
import ClienteService from "../../service/ClienteService";

import Select2 from "vue3-select2-component";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(Buttons);
DataTable.use(ButtonsHtml5);

export default {
  components: { DataTable, FacturaPosView, Select2 },
  data() {
    return {
      GLOBAL,
      FACTOR_CONVERSION: 1.11112,
      table: null,
      reporteService: null,
      person: null,
      cache: false,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totaleds: 0,
      totalimpuestos: 0,
      totales: 0,
      descuentos: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      fdescuentos: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      venta: [],
      facturaKey: 0,
      factura: [],
      datatable: null,
      clienteService: null,
      clientes: [],
      cliente: "",
      documento_id: "",
      page: 0,
      loading: true,
      columns: [
        { title: "Fecha", class: "text-center", data: "fecha" },
        {
          title: "Mang",
          width: "80px",
          data: "manguera",
          render: function (data, type, row) {
            return "M." + row.manguera;
          },
        },
        {
          title: "Prefijo/Consecutivo",
          render: function (data, type, row) {
            return row.prefijo+"-"+row.consecutivo;
          },
        },
        {
          title: "Hash",
          data: "hash",
          render: function (data, type, row) {
            return row.hasp;
          },
        },
        { title: "Promotor", data: "persona_nombre" },
        { title: "Cliente", data: "tercero_nit" },
        { title: "Cliente", data: "tercero_nombre" },
        { title: "Producto", data: "producto_nombre" },
        { title: "UND", data: "unidad_codigo" },
        {
          title: "Precio",
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.producto_precio);
          },
        },
        { title: "Cant", data: "cantidad", class: "text-right" },
        {
          title: "Cant m3",
          data: "cantidadm3",
          class: "text-right",
          render: function (data, type, row) {
            var factorConversion = this.FACTOR_CONVERSION;
            if (row.unidad_id == 2) {
              factorConversion = 1;
            }

            return GLOBAL.COUNTRY == "MX"
              ? GLOBAL.FORMATO_NUMBER(row.cantidad / factorConversion)
              : "";
          }.bind(this), // Asegura que el contexto sea el del componente
        },
        {
          title: "Descuento",
          class: "text-center",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.descuento_total);
          },
        },
        {
          title: "Venta",
          class: "text-right",
          render: function (data, type, row) {
            return GLOBAL.FORMATO_MONEY_BASIC(row.venta_total);
          },
        },
        {
          title: "Acciones",
          data: "boton",
          render: function (data, type, row) {
            return "";
          },
        },
      ],
      options: {
        ...GLOBAL.TABLE_OPTIONS,
        createdRow: function (row, data, dataIndex) {
          const vueInstance = this;
        }.bind(this),
      },
    };
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));

    this.FACTOR_CONVERSION = 1;
    try {
      this.FACTOR_CONVERSION = this.person.parametros.factor_m3;
      console.log(this.FACTOR_CONVERSION);
    } catch (error) {}

    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new ReporteService();
    this.clienteService = new ClienteService();
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 23:59"
    );
    $("input[datatype='fecha']").datetimepicker();
    this.getReporteEquipos();
    this.getListaCliente();
  },
  methods: {
    refrescarFactura() {
      this.facturaKey += 1;
    },
    limpiarCliente() {
      this.cliente = "";
    },
    openMe(item) {
      this.venta = item;
      this.venta.hash = this.venta.hasp;
      this.venta.numero = this.venta.consecutivo;
      this.venta.hash = this.venta.hasp;
      this.reporteService
        .getFactura(this.person, this.venta)
        .then((data) => {
          this.factura = data;
          if (typeof this.venta.hasp != "undefined") {
            this.factura.hash = this.venta.hasp;
          }
          this.refrescarFactura();
        })
        .then(() => {
          $("#myModal").modal("show");
        });
    },

    changeMe: function (movimiento) {
      if (this.clientes.length == 0) {
        this.getListaCliente();
      }
      this.documento_id = movimiento.documento_id;
      $("#myChange").modal("show");
    },

    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          this.clientes = [];
          for (var i in data) {
            this.clientes.push({ id: data[i]._id, text: data[i].nombres });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    getReporteEquipos() {
      this.reporte = [];
      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      this.loading = true;
      var filtros = {
        cliente: this.cliente,
      };
      this.reporteService
        .getListaMovimientos(
          this.person,
          fechainicio,
          fechafin,
          GLOBAL.TIPO_ORIGEN.COMBUSTIBLE,
          filtros
        )
        .then((data) => {
          this.reporte = data.data;
          this.totalventas = 0;
          this.totalimpuestos = 0;
          this.totalCantidad = 0;
          this.totales = 0;
          this.descuentos = 0;
          var x = 0;

          for (const i in this.reporte) {
            this.totalimpuestos += this.reporte[i].impuesto_total;
            this.totalCantidad += this.reporte[i].cantidad;
            this.totales += this.reporte[i].venta_total;
            this.descuentos += this.reporte[i].descuento_total;
            x++;
          }

          this.totalventas = x;
          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);

          this.fdescuentos = GLOBAL.FORMATO_MONEY(this.descuentos);
          this.fecha_inicio_reporte = fechainicio;
          this.fecha_final_reporte = fechafin;

          this.loading = false;
        });
    },
  },
};
</script>
